/* eslint-disable import/extensions */
import React, { PureComponent } from 'react';

import { Checkbox, Link, Panel } from '@philips-emr/tws-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, eventListener, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services';
import { getLostProps, propagateProps } from '@philips-emr/tws-utils';

import './hpms-terms-of-use.scss';
import HpmsTermCheckboxAPI from './hpms-terms-of-use-api';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: HpmsTermCheckboxAPI })
class HpmsTermCheckbox extends PureComponent {

  static propTypes = {
    routeTerm: string,
    routeWarning: string,
    onChange: eventListener,
    onClickTerm: eventListener,
    onClickWarning: eventListener,
    enabled: bool,
    value: bool,
    responsabilityTerm: bool,
  }

  getCheckbox() {
    const { value, responsabilityTerm } = this.props;
    const lostProps = getLostProps(HpmsTermCheckbox, this.props);

    if (responsabilityTerm) {
      return propagateProps(<Checkbox value={value} />, { ...this.props, ...lostProps });
    }

    return propagateProps(<Checkbox label="beneficiary.eu-concordo-com" value={value} />, { ...this.props, ...lostProps });
  }

  getLinks() {
    const { onClickTerm, onClickWarning, responsabilityTerm } = this.props;
    if (responsabilityTerm) {
      return (
        <>
          <Link value="beneficiary.i-agree-with-the-terms" onClick={onClickTerm} />
        </>
      );

    }
    return (
      <>
        <Link value="beneficiary.termos-uso" onClick={onClickTerm} />
        {` ${msg('beneficiary.letra-e')} `}
        <Link value="beneficiary.aviso-privacidade" onClick={onClickWarning} />
      </>
    );
  }
  renderComponents() {
    return (
      <Panel padding = "1rem 0 1rem 0" >
      <div className="c-hpms-term-checkbox__wrapper">
        <div className="c-hpms-term-checkbox__checkbox">
          {this.getCheckbox()}
        </div>
        <div className="c-hpms-term-checkbox__link">
          {this.getLinks()}
        </div>
      </div>
      </Panel>
    );
  }

  render() {
    return this.renderComponents();
  }

}

export default HpmsTermCheckbox;
